import React from 'react';
import './style.scss';
import ColombiaDirectDebitStatusForm from './co-form';
import ArgentinaDirectDebitStatusForm from './ar-form';

export default class DirectDebitStatus extends React.Component<any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { country } = this.props;

    switch (country) {
      case 'AR':
        return <ArgentinaDirectDebitStatusForm {...this.props} />;
      case 'CO':
        return <ColombiaDirectDebitStatusForm {...this.props} />;
    }
  }
}
